export const ADD_ROLE_DRAWER = 'ADD_ROLE_DRAWER';
export const EDIT_ROLE_DRAWER = 'EDIT_ROLE_DRAWER';
export const EDIT_ROLE_DRAWER_ASSIGN_USERS_TAB = 'EDIT_ROLE_DRAWER_ASSIGN_USERS_TAB';
export const CLONE_ROLE_DRAWER = 'CLONE_ROLE_DRAWER';

export const FORM_FIELDS = {
    NAME: 'name',
    DESC: 'description',
    EMAIL: 'email',
};

export const FIELD_CHAR_LIMITS = {
    [FORM_FIELDS.NAME]: 100,
    [FORM_FIELDS.DESC]: 250,
};

export const VALIDATION_REGEXP = {
    [FORM_FIELDS.NAME]: new RegExp(/^[ A-Za-z0-9][ A-Za-z0-9:-]*$/),
    [FORM_FIELDS.EMAIL]: new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ),
};

export const SET_SCREEN_MESSAGE_ACTION = 'SET_SCREEN_MESSAGE_ACTION';
export const ROLE_DETAILS_KEY = 'roleDetails';
export const ASSIGNED_USERS_KEY = 'assignedUsers';

export default ADD_ROLE_DRAWER;
